import { render, staticRenderFns } from "./messageLogs.vue?vue&type=template&id=1a6671ee&scoped=true"
import script from "./messageLogs.vue?vue&type=script&lang=js"
export * from "./messageLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6671ee",
  null
  
)

export default component.exports